import { Link, NavLink } from "react-router-dom";

const links = [
    { to: "/generator", label: "Generator" },
    { to: "/library", label: "Library" },
    { to: "/dashboard", label: "Signal" },
    { to: "/operations", label: "Ops" },
    { to: "/operator", label: "Operator" },
    { to: "/settings", label: "Settings" },
];

export const Nav = () => {
    return (
        <header
            data-testid="main-nav"
            className="sticky top-0 z-50 border-b border-[#262626] bg-[#050505]/95 backdrop-blur-sm"
        >
            <div className="flex items-center justify-between px-6 md:px-12 h-14">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="flex items-center gap-3 group"
                >
                    <div className="w-6 h-6 bg-[#ff2a2a] group-hover:bg-white transition-colors" />
                    <span className="font-heading font-black uppercase tracking-tighter text-[#f5f5f0] text-lg">
                        Dark<span className="text-[#ff2a2a]">8</span>-s
                    </span>
                    <span className="font-mono-d8 text-[10px] text-[#8a8a8a] uppercase tracking-[0.2em] hidden md:inline-block ml-2">
                        [ 8.00s / ENGINEERED ]
                    </span>
                </Link>
                <nav className="flex items-center gap-1">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `px-3 md:px-4 py-2 font-mono-d8 text-xs uppercase tracking-[0.2em] transition-colors ${
                                    isActive
                                        ? "text-[#f5f5f0] bg-[#1a1a1a]"
                                        : "text-[#8a8a8a] hover:text-[#f5f5f0]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>
            </div>
        </header>
    );
};

export default Nav;
